import service from './request'

/**
 * 获取公告列表
 */
export const noticeGetList = data => {
    return service({
        showLoading: true,
        url: '/platform/notice/publish/getList',
        method: 'post',
        type: 'body',
        data
    })
}
/**
 * 获取公告列表（个人）
 */
 export const getPersonPublishList = data => {
    return service({
        showLoading: true,
        url: '/platform/notice/publish/getPersonPublishList',
        method: 'post',
        type: 'body',
        data
    })
}
/**
 * 获取个人公告列表
 */
 export const getListByUserId = data => {
    return service({
        showLoading: true,
        url: '/platform/notice/getListByUserId',
        method: 'post',
        type: 'body',
        data
    })
}
/**
 * 获取公告详情
 */
 export const noticGetInfo = data => {
    return service({
        showLoading: true,
        url: '/platform/notice/publish/getInfo',
        method: 'post',
        type: 'body',
        data
    })
}
/**
 * 获取个人公告详情
 */
 export const noticGetInfoByUserId = data => {
    return service({
        showLoading: true,
        url: '/platform/notice/getInfo',
        method: 'post',
        type: 'body',
        data
    })
}
/**
 * 设置公告为已读
 */
 export const setReadFlag = data => {
    return service({
        showLoading: false,
        url: '/platform/notice/setReadFlag',
        method: 'post',
        type: 'body',
        data
    })
}
/**
 * 获取用户公告列表信息
 */
 export const getUserNoticeList = params => {
    return service({
        showLoading: false,
        url: '/platform/notice/publish/getUserNoticeList',
        method: 'post',
        params
    })
}
/**
 * 获取公告短信列表信息
 */
 export const getSmsList = params => {
    return service({
        showLoading: false,
        url: '/platform/notice/publish/getSmsList',
        method: 'post',
        params
    })
}
/**
 * 获取公告外发渠道列表
 */
 export const getChannelList = params => {
    return service({
        showLoading: false,
        url: '/platform/notice/publish/getChannelList',
        method: 'post',
        params
    })
}
/**
 * 获取公告邮件列表
 */
 export const getEmailList = params => {
    return service({
        showLoading: false,
        url: '/platform/notice/publish/getEmailList',
        method: 'post',
        params
    })
}
/**
 * 获取公告审批跟进信息
 */
 export const getFollowRecList = data => {
    return service({
        showLoading: false,
        url: '/platform/notice/publish/getFollowRecList',
        method: 'post',
        type: 'body',
        data
    })
}
/**
 * 创建公告
 */
 export const noticAddInfo = data => {
    return service({
        showLoading: true,
        url: '/platform/notice/publish/addInfo',
        method: 'post',
        type: 'body',
        data
    })
}
/**
 * 修改公告
 */
 export const noticUpdateInfo = data => {
    return service({
        showLoading: true,
        url: '/platform/notice/publish/updateInfo',
        method: 'post',
        type: 'body',
        data
    })
}
/**
 * 删除公告
 */
 export const noticDelInfo = data => {
    return service({
        showLoading: true,
        url: '/platform/notice/publish/delInfo',
        method: 'post',
        type: 'body',
        data
    })
}
/**
 * 变更公告有效标识
 */
 export const setUseFlag = data => {
    return service({
        showLoading: false,
        url: '/platform/notice/publish/setUseFlag',
        method: 'post',
        type: 'body',
        data
    })
}
/**
 * 公告审批处理
 */
 export const noticCheck = data => {
    return service({
        showLoading: true,
        url: '/platform/notice/publish/check',
        method: 'post',
        type: 'body',
        data
    })
}
/**
 * 获取公告模板列表
 */
 export const getTemplateList = data => {
    return service({
        showLoading: true,
        url: '/platform/notice/getTemplateList',
        method: 'post',
        type: 'body',
        data
    })
}
/**
 * 获取公告类型列表
 */
 export const getNoticeTypeList = data => {
    return service({
        showLoading: true,
        url: '/platform/notice/getNoticeTypeList',
        method: 'post',
        type: 'body',
        data
    })
}
/**
 * 获取菜单列表数据
 */
export const getMenuList = data => {
  return service({
    showLoading: true,
    url: '/platform/baseData/getUserMenuList',
    method: 'post',
    data
  })
}
/**
 * 获取部门人员列表数据
 */
 export const getOrgUserList = data => {
    return service({
        showLoading: false,
        url: '/platform/baseData/getOrgUserList',
        method: 'post',
        type: 'body',
        data
    })
}
/**
 * 获取通讯录人员列表数据
 */
 export const getLinkBookMemberList = data => {
    return service({
        showLoading: true,
        url: '/platform/baseData/getLinkBookMemberList',
        method: 'post',
        type: 'body',
        data
    })
}
/**
 * 获取渠道列表数据
 */
 export const baseGetChannelList = data => {
    return service({
        showLoading: true,
        url: '/platform/baseData/getChannelList',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 公告配置更新
 */
 export const cfgUpdateInfo = data => {
    return service({
        showLoading: true,
        url: '/platform/notice/cfg/updateInfo',
        method: 'post',
        type: 'body',
        data
    })
}
/**
 * 获取公告配置信息
 */
 export const cfgGetInfo = data => {
    return service({
        showLoading: true,
        url: '/platform/notice/cfg/getInfo',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 获取公告模板列表
 */
export const templateGetList = data => {
    return service({
        showLoading: true,
        url: '/platform/notice/template/getList',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 获取公告模板详情
 */
export const templateGetInfo = data => {
    return service({
        showLoading: true,
        url: '/platform/notice/template/getInfo',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 获取公告模板添加
 */
export const templateAddInfo = data => {
    return service({
        showLoading: true,
        url: '/platform/notice/template/addInfo',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 获取公告模板修改
 */
export const templateUpdateInfo = data => {
    return service({
        showLoading: true,
        url: '/platform/notice/template/updateInfo',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 获取公告模板删除
 */
export const templateDelInfo = data => {
    return service({
        showLoading: true,
        url: '/platform/notice/template/delInfo',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 获取公告类型管理列表
 */
export const noticeTypeGetList = data => {
    return service({
        showLoading: true,
        url: '/platform/notice/type/getList',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 添加公告类型
 */
export const noticeTypeAddInfo = data => {
    return service({
        showLoading: true,
        url: '/platform/notice/type/addInfo',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 修改公告类型
 */
export const noticeTypeUpdateInfo = data => {
    return service({
        showLoading: true,
        url: '/platform/notice/type/updateInfo',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 删除公告类型
 */
export const noticeTypeDelInfo = data => {
    return service({
        showLoading: true,
        url: '/platform/notice/type/delInfo',
        method: 'post',
        type: 'body',
        data
    })
}




// WEBPACK FOOTER //
// ./src/http/NoticManagement.js